import * as React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import useStyle from '../../../css/styles';

// Update log
// FB  6192   02/06/2023  DK  Added screen displayed after registration

export default function RegisterUser(props: any) {
    const styles = useStyle();

    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                Create and Access your Account
            </Typography>
            <Typography>
                Account created! Access your healthcare records, message your physician, pay your bill, and book an appointment.
            </Typography>
            <hr />
            <Grid container spacing={2} direction="column" justifyContent="flex-start" alignItems="strech">
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        variant='contained'
                        className={styles.navigationButton}
                        href="/user/login"
                    >
                        View account
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

function useHistory() {
    throw new Error('Function not implemented.');
}
